import UserProfilePopup from './UserProfilePopup'
import UserATProfileSection from './UserATProfileSection'
import $ from 'jquery'
import _ from 'underscore'

function UserATProfilePopup() {
}

UserATProfilePopup.prototype = _.create(UserProfilePopup.prototype);

UserATProfilePopup.prototype.init = function(data,
                                             isLocked,
                                             highlightStartingNewWeekSection,
                                             isUserCannotSeenAnyPages,
                                             successCallback,
                                             enabledFeatures,
                                             areMailSettingsSpecified) {
    this._enabledFeatures = enabledFeatures;
    this._areMailSettingsSpecified = areMailSettingsSpecified;
    this._isUserCannotSeenAnyPages = isUserCannotSeenAnyPages;

    UserProfilePopup.prototype.init.call(this, data, isLocked, successCallback);

    if (highlightStartingNewWeekSection) {
        $(".startingNewWeekBlock").addClass("highlighted");
        setTimeout(function() { $(".startingNewWeekBlock").removeClass("highlighted"); }, 2000);
    }
    if (isUserCannotSeenAnyPages) {
        var self = this;
        this.onShowAnimationEnd = function() {
            self._userProfileSection.scrollToPermissionsSection();
        }
    }
    return this;
};

UserATProfilePopup.prototype.createUserProfileSection = function(data) {
    return new UserATProfileSection().init(
        this._popupEl[0],
        data,
        this._changesCallback,
        this._validateCallback,
        true,
        this._enabledFeatures,
        this._areMailSettingsSpecified,
        this._isUserCannotSeenAnyPages
    )
};

UserATProfilePopup.prototype.getServiceAndMethod = function() {
    return "EditATProfileService.updateProfile";
};

UserATProfilePopup.prototype.getDataToCommit = function() {
    const data = this._userProfileSection;
    return [
        {
            firstName: data.getFirstName(),
            middleName: data.getMiddleInitial(),
            lastName: data.getLastName(),
            email: data.getEmail(),
            username: data.getUsername(),
            plainOldPassword: data.getOldPassword(),
            plainPassword: data.getNewPassword(),
            keepAllTasksFromPreviousWeek: data.getStartingNewWeekOption()
            // TODO: notifications are disabled for now, remove or rewrite later
            // receiveUserChangesNotification: data.getReceiveUserChangesOption(),
            // receiveCommentsChangesNotification: data.getReceiveCommentsChangesOption()
        }
    ];
};

export default UserATProfilePopup



// WEBPACK FOOTER //
// ./web/js/userProfile/UserATProfilePopup.js